export default __webpack_public_path__ + "static/media/videoOff.d774498a.svg";